import React from "react";

import { useIntl } from "react-intl";

import { DeploymentService } from "Api/organizations/projects/environments/deployments/types";
import LabeledInfo from "Components/LabeledInfo";
import { capitalize } from "Libs/utils";

type WorkerInfosProps = {
  worker: DeploymentService;
  profileLabel: string;
};

const WorkerInfos = ({ worker, profileLabel }: WorkerInfosProps) => {
  const intl = useIntl();
  const instancesCount = worker.instance_count;

  const formatLabel = (label: string) => {
    if (!label) {
      return intl.formatMessage({ id: "unknown" });
    }
    const splitLabel = label.split(":");
    if (splitLabel[0] === "php") {
      return splitLabel[0].toUpperCase() + " " + splitLabel[1];
    }
    return capitalize(splitLabel[0]) + " " + splitLabel[1];
  };

  const versionEl = (
    <LabeledInfo
      gridColumn="auto"
      label={intl.formatMessage({ id: "runtime" })}
      value={formatLabel(worker?.type)}
      shouldCapitalize={false}
    />
  );

  const profileEl = (
    <LabeledInfo
      gridColumn="auto"
      label={intl.formatMessage({ id: "profile_dialog" })}
      value={
        profileLabel?.toLocaleUpperCase() ??
        intl.formatMessage({ id: "unknown" })
      }
    />
  );

  const instancesEl = (
    <LabeledInfo
      gridColumn="auto"
      label={intl.formatMessage({ id: "instances_dialog" })}
      value={instancesCount ?? intl.formatMessage({ id: "unknown" })}
    />
  );

  return (
    <>
      {versionEl}
      {profileEl}
      {instancesEl}
    </>
  );
};

export default WorkerInfos;
